import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { EPartialCheckboxValue } from '../../../enums/EPartialCheckboxValue';
import { CheckboxGroupChangeModelLazy } from '../../../models/CheckboxGroupChangeModel';
export function prepareCheckboxGroupChangeModel(nestedCheckboxesService, values) {
  switch (nestedCheckboxesService.titledCheckboxValue) {
    case EPartialCheckboxValue.All:
      {
        var calcGroupValues = function calcGroupValues() {
          return Array.of();
        };

        var calcAllValues = function calcAllValues() {
          var groupIds = new Set(nestedCheckboxesService.group.items.map(function (item) {
            return item.value;
          }));
          return Array.from(values).filter(function (value) {
            return !groupIds.has(value);
          });
        };

        var calcAllItems = function calcAllItems() {
          var allValuesCollection = new Set(calcAllValues());
          return nestedCheckboxesService.group.items.filter(function (item) {
            return allValuesCollection.has(item.value);
          });
        };

        return new CheckboxGroupChangeModelLazy(nestedCheckboxesService.group, calcAllValues, calcGroupValues, calcAllItems);
      }

    case EPartialCheckboxValue.Partial:
    case EPartialCheckboxValue.None:
      {
        var _calcGroupValues = function _calcGroupValues() {
          return nestedCheckboxesService.group.items.map(function (item) {
            return item.value;
          });
        };

        var _calcAllValues = function _calcAllValues() {
          return Array.from(new Set([].concat(_toConsumableArray(values), _toConsumableArray(_calcGroupValues()))));
        };

        var _calcAllItems = function _calcAllItems() {
          var allValuesCollection = new Set(_calcAllValues());
          return nestedCheckboxesService.group.items.filter(function (item) {
            return allValuesCollection.has(item.value);
          });
        };

        return new CheckboxGroupChangeModelLazy(nestedCheckboxesService.group, _calcAllValues, _calcGroupValues, _calcAllItems);
      }
  }
}